import styled from 'styled-components';

export const StyledContainer = styled.div`
	position: relative;
	height: calc(100% - 159px);
	width: ${
		props => 
			props.state.isEditorSidebarOpened 
				? props.state.isEditorNewDocSidebarOpened || props.state.isEditorOpenDocSidebarOpened 
						? "calc(100% - 560px)"
						: "calc(100% - 60px)"
				: "100%"
	};
	@media all and (max-width: 1200px) {
		@media (orientation: portrait) {
			width: 100%;
		}
		@media (orientation: landscape) {
			width: ${
				props => 
					props.state.isEditorSidebarOpened 
						? props.state.isEditorNewDocSidebarOpened || props.state.isEditorOpenDocSidebarOpened 
								? "50%"
								: "calc(100% - 60px)"
						: "100%"
			};
		}
	}
`;

export const EditorBody = styled.div`
	@media (orientation: portrait) {
		display: none;
	}
	@media (orientation: landscape) {
		display: block;
	}
`;

export const EditorPortrait = styled.div`
	position: absolute;
	width: 100%;
	height: calc(100% - 60px);
	top: 60px;
	left: 0px;
	display: none;
	z-index: 1200;
	align-items: center;
	justify-content: center;
	background: rgba(79, 79, 79, 0.60);
	backdrop-filter: blur(5px);
	overflow: hidden;
	@media (orientation: portrait) {
		display: flex;
	}
	@media (orientation: landscape) {
		display: none;
	}
`;
export const EditorPortraitBody = styled.div`
	align-items: center;
	justify-content: center;
	flex-direction: row;
	& > *:not(:last-child) {
    	margin-bottom: 47px;
  	}
`;
export const EditorPortraitText = styled.div`
	color: #FFF;
	text-align: center;
	text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
	font-family: Fira Sans;
	font-size: 30px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
`;
export const EditorPortraitSubText = styled.div`
	color: #FFF;
	text-align: center;
	text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
	font-family: Fira Sans;
	font-size: 20px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
`;
export const EditorPortraitIcon = styled.div`
	width: 100%;
	text-align: center;
	height: 70px;
	flex-shrink: 0;
	& > svg {
		fill: #FFF;
		filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
	}
`;